__webpack_require__.p = "https://fundraising.marysmeals.org/";